import { render, staticRenderFns } from "./exExpertScoreSummary.vue?vue&type=template&id=fa05bfe6&scoped=true"
import script from "./exExpertScoreSummary.vue?vue&type=script&lang=js"
export * from "./exExpertScoreSummary.vue?vue&type=script&lang=js"
import style0 from "./exExpertScoreSummary.vue?vue&type=style&index=0&id=fa05bfe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa05bfe6",
  null
  
)

export default component.exports